import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '@/store/index.js'

const apiPath = '/api/v1/'

const ApiService = {
  init () {
    Vue.use(VueAxios, axios)
    Vue.axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}`
  },

  setHeader () {
    const token = store.getters.bearerToken
    if (token) {
      Vue.axios.defaults.headers.common.Authorization = `Bearer ${token}`
    }
  },

  query (resource, params) {
    return Vue.axios.get(`${apiPath}${resource}`, { params })
  },

  get (resource, slug = '') {
    return Vue.axios.get(`${apiPath}${resource}/${slug}`)
  },
  getArray (resource, slug = '', params) {
    return Vue.axios.get(`${apiPath}${resource}/${slug}`, { responseType: 'arraybuffer', params })
  },
  postGetArray (resource, slug = '', params) {
    return Vue.axios.post(`${apiPath}${resource}/${slug}`, params, { responseType: 'arraybuffer' })
  },
  post (resource, params) {
    return Vue.axios.post(`${apiPath}${resource}`, params)
  },
  /***
   * post an action to the endpoint /api/v1/tower/{slug}/update-tower
   * @param {string} resource entity to modify
   * @param {string} slug identifier of the entity
   * @param {string} action the API action to peform ie: update-tower
   * @param {object} params to push in body
   * @returns {Promise<AxiosResponse<any>>}
   */
  postAction (resource, slug, action, params) {
    return Vue.axios.post(`${apiPath}${resource}/${slug}/${action}`, params)
  },
  put (resource, params) {
    return Vue.axios.put(`${apiPath}${resource}`, params)
  },
  update (resource, slug, params) {
    return Vue.axios.put(`${apiPath}${resource}/${slug}`, params)
  },

  delete (resource, slug) {
    return Vue.axios.delete(`${apiPath}${resource}/${slug}`)
  },
}

export default ApiService
